var map = {
	"./bio_invest/favicon.png": 8020,
	"./clinwire/favicon.png": 8376,
	"./crofter/favicon.png": 3575,
	"./inova/favicon.png": 2787,
	"./labza/favicon.png": 5126,
	"./special_chem/favicon.png": 2481,
	"./zapyrus/favicon.png": 2537,
	"./zebra/favicon.png": 4004,
	"./zymewire/favicon.png": 2145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4687;